/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.8.2.0 (NJsonSchema v10.2.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { CommonServices } from "@/services/CommonServices";
import * as OM from "@/Model";
import { baseUrl } from '@/config';

class _AuthClient {

    

                
            register(
                model:OM.LanguageCredential,showSpinner = true): Promise<OM.BaseApiLoginResponse> {
                        return CommonServices.defaultPost<OM.BaseApiLoginResponse>(baseUrl + 'api/Auth/Register', model ,{}, showSpinner );

                    }
    

                
            createLogin(
                model:OM.LanguageCredential,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(baseUrl + 'api/Auth/CreateLogin', model ,{}, showSpinner );

                    }
    

                
            getLoginData(
                identifier:string,showSpinner = true): Promise<OM.LoginData> {
                        return CommonServices.defaultGet<OM.LoginData>(baseUrl + 'api/Auth/GetLoginData',{ identifier  }, showSpinner);

                    }
    

                
            updateLoginData(
                model:OM.UpdateCredentialVm,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(baseUrl + 'api/Auth/UpdateLoginData', model ,{}, showSpinner );

                    }
    

                
            tokenUpgrade(
                token:string,showSpinner = true): Promise<OM.LoggedUserVM> {
                        return CommonServices.defaultGet<OM.LoggedUserVM>(baseUrl + 'api/Auth/TokenUpgrade',{ token  }, showSpinner);

                    }
    

                
            checkLogin(showSpinner = true): Promise<OM.LoggedUserVM> {
                        return CommonServices.defaultGet<OM.LoggedUserVM>(baseUrl + 'api/Auth/CheckLogin',{  }, showSpinner);

                    }
    

                
            changeLanguageAndGetToken(
                language:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(baseUrl + 'api/Auth/ChangeLanguageAndGetToken',{ language  }, showSpinner);

                    }
    

                
            login(
                model:OM.LanguageCredential,showSpinner = true): Promise<OM.BaseApiLoginResponse> {
                        return CommonServices.defaultPost<OM.BaseApiLoginResponse>(baseUrl + 'api/Auth/Login', model ,{}, showSpinner );

                    }
    

                
            changePassword(
                newPassword:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(baseUrl + 'api/Auth/ChangePassword',{ newPassword  }, showSpinner);

                    }
    

                
            resetConfirmationCode(showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(baseUrl + 'api/Auth/ResetConfirmationCode',{  }, showSpinner);

                    }
    

                
            resetPassword(
                username:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(baseUrl + 'api/Auth/ResetPassword',{ username  }, showSpinner);

                    }
    

                
            confirm(
                loginIdentifier:string,
                confirmationCode:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(baseUrl + 'api/Auth/Confirm',{ loginIdentifier , confirmationCode  }, showSpinner);

                    }
    }

export let AuthClient = new _AuthClient();

class _BaseTavolaClient {

    

                
            getAll(showSpinner = true): Promise<OM.FondoTavola[]> {
                        return CommonServices.defaultGet<OM.FondoTavola[]>(baseUrl + 'api/BaseTavola/GetAll',{  }, showSpinner);

                    }
    }

export let BaseTavolaClient = new _BaseTavolaClient();

class _LocalizedClient {

    

                
            saveLocalizedEntity(
                item:OM.LocalizedEntity,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(baseUrl + 'api/Localized/SaveLocalizedEntity', item ,{}, showSpinner );

                    }
    

                
            getAppDictionary(showSpinner = true): Promise<OM.LocalizedEntity[]> {
                        return CommonServices.defaultGet<OM.LocalizedEntity[]>(baseUrl + 'api/Localized/GetAppDictionary',{  }, showSpinner);

                    }
    

                
            getAll(showSpinner = true): Promise<OM.LocalizedEntity[]> {
                        return CommonServices.defaultGet<OM.LocalizedEntity[]>(baseUrl + 'api/Localized/GetAll',{  }, showSpinner);

                    }
    

                
            getEnabledLanguages(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(baseUrl + 'api/Localized/GetEnabledLanguages',{  }, showSpinner);

                    }
    

                
            getSupportedLanguages(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(baseUrl + 'api/Localized/GetSupportedLanguages',{  }, showSpinner);

                    }
    

                
            saveLocalizedValue(
                item:OM.KeyValuePairOfStringAndString,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(baseUrl + 'api/Localized/SaveLocalizedValue', item ,{}, showSpinner );

                    }
    

                
            editLocalizedValue(
                value:OM.LocalizedEntity,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(baseUrl + 'api/Localized/EditLocalizedValue', value ,{}, showSpinner );

                    }
    }

export let LocalizedClient = new _LocalizedClient();

class _ProductClient {

    

                
            getBySku(
                sku:string,showSpinner = true): Promise<OM.Product> {
                        return CommonServices.defaultGet<OM.Product>(baseUrl + 'api/Product/GetBySku',{ sku  }, showSpinner);

                    }
    

                
            getProductCategories(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(baseUrl + 'api/Product/GetProductCategories',{  }, showSpinner);

                    }
    

                
            getByCategory(
                req:OM.GetProductsRequest,showSpinner = true): Promise<OM.CategoryWithProductsVm> {
                        return CommonServices.defaultPost<OM.CategoryWithProductsVm>(baseUrl + 'api/Product/GetByCategory', req ,{}, showSpinner );

                    }
    

                
            getByCollezione(
                req:OM.GetProductsRequest,showSpinner = true): Promise<OM.CategoryWithProductsVm> {
                        return CommonServices.defaultPost<OM.CategoryWithProductsVm>(baseUrl + 'api/Product/GetByCollezione', req ,{}, showSpinner );

                    }
    

                
            getAll(showSpinner = true): Promise<OM.Product[]> {
                        return CommonServices.defaultGet<OM.Product[]>(baseUrl + 'api/Product/GetAll',{  }, showSpinner);

                    }
    }

export let ProductClient = new _ProductClient();

class _ScheduledClient {

    

                
            syncWithWc(
                password:string,showSpinner = true): Promise<OM.Tavola> {
                        return CommonServices.defaultGet<OM.Tavola>(baseUrl + 'api/Scheduled/SyncWithWc',{ password  }, showSpinner);

                    }
    }

export let ScheduledClient = new _ScheduledClient();

class _StepConfigClient {

    

                
            getStepConfigs(showSpinner = true): Promise<OM.StepConfig[]> {
                        return CommonServices.defaultGet<OM.StepConfig[]>(baseUrl + 'api/StepConfig/GetStepConfigs',{  }, showSpinner);

                    }
    

                
            save(
                item:OM.StepConfig,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(baseUrl + 'api/StepConfig/Save', item ,{}, showSpinner );

                    }
    }

export let StepConfigClient = new _StepConfigClient();

class _TavolaClient {

    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.Tavola> {
                        return CommonServices.defaultGet<OM.Tavola>(baseUrl + 'api/Tavola/GetById',{ identifier  }, showSpinner);

                    }
    

                
            getPresets(showSpinner = true): Promise<OM.Tavola[]> {
                        return CommonServices.defaultGet<OM.Tavola[]>(baseUrl + 'api/Tavola/GetPresets',{  }, showSpinner);

                    }
    }

export let TavolaClient = new _TavolaClient();

class _TovagliettaClient {

    

                
            getAll(showSpinner = true): Promise<OM.Tovaglietta[]> {
                        return CommonServices.defaultGet<OM.Tovaglietta[]>(baseUrl + 'api/Tovaglietta/GetAll',{  }, showSpinner);

                    }
    }

export let TovagliettaClient = new _TovagliettaClient();

class _UserClient {

    

                
            getAllForList(showSpinner = true): Promise<OM.BaseUserForListVm[]> {
                        return CommonServices.defaultGet<OM.BaseUserForListVm[]>(baseUrl + 'api/User/GetAllForList',{  }, showSpinner);

                    }
    }

export let UserClient = new _UserClient();

class _AttachmentClient {

                upload
            (file: File, parentIdentifier: string, parentName: string, showSpinner = true, progressFn: (prog) => void = null): Promise<OM.CloudAttachmentReference> {
                return CommonServices.uploadFileToUrl<OM.CloudAttachmentReference>(baseUrl + 'api/Attachment/Upload?parentIdentifier=' + parentIdentifier + '&parentName=' + parentName, file,
                {}
                , progressFn, showSpinner);
            }
    

                
            download(
                attachmentIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(baseUrl + 'api/Attachment/Download', attachmentIdentifier ,{}, showSpinner );

                    }
    

                
            delete(
                attachmentIdentifier:string,
                parentIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(baseUrl + 'api/Attachment/Delete',{ attachmentIdentifier , parentIdentifier  }, showSpinner);

                    }
    }

export let AttachmentClient = new _AttachmentClient();

class _LocalizationClient {

    

                
            getAppDictionary(showSpinner = true): Promise<OM.LocalizedEntity[]> {
                        return CommonServices.defaultGet<OM.LocalizedEntity[]>(baseUrl + 'api/Localization/GetAppDictionary',{  }, showSpinner);

                    }
    

                
            getAll(showSpinner = true): Promise<OM.LocalizedEntity[]> {
                        return CommonServices.defaultGet<OM.LocalizedEntity[]>(baseUrl + 'api/Localization/GetAll',{  }, showSpinner);

                    }
    

                
            getEnabledLanguages(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(baseUrl + 'api/Localization/GetEnabledLanguages',{  }, showSpinner);

                    }
    

                
            getSupportedLanguages(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(baseUrl + 'api/Localization/GetSupportedLanguages',{  }, showSpinner);

                    }
    

                
            saveLocalizedValue(
                item:OM.KeyValuePairOfStringAndString,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(baseUrl + 'api/Localization/SaveLocalizedValue', item ,{}, showSpinner );

                    }
    

                
            editLocalizedValue(
                value:OM.LocalizedEntity,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(baseUrl + 'api/Localization/EditLocalizedValue', value ,{}, showSpinner );

                    }
    }

export let LocalizationClient = new _LocalizationClient();

interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}